import React, {useEffect, useState} from 'react';
import axiosInstance from "../../api";
import {Box, Paper} from "@material-ui/core";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AgentSearchCriteriaCreateTile from "./AgentSearchCriteriaCreateTile";
import AgentSearchCriteriaListViewTile from "./AgentSearchCriteriaListViewTile";
import {useUserContext} from "../../context/UserContext";
import AgentMappedRecordsListView from "./AgentMappedRecordsListView";
import AgentTaggedLeadsListView from "./AgentTaggedLeadsListView";
import AgentContactInfoView from "./AgentContactInfoView";
import AgentResolvedLeadsListView from "./AgentResolvedLeadsListView";

function AgentDashboard() {
    const [tabValue, setTabValue] = React.useState(0);
    const {user,dispatch} = useUserContext();

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    /*const [errorMessage, setErrorMessage] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);

    const downloadLeads = async () => {
        axiosInstance.get("lead-agent/download")
            .then(data => {
                const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const blob = base64StringToBlob(data.value,contentType);
                FileDownload(blob, `file.xlsx`);
            })
            .catch(error => {
                console.error(error);
                setErrorMessage("An error has occurred. Please try again later.");
            })
            .finally(() => setShowSpinner(false));
    }*/

    return (
        <Box m={4}>
            <br/>
            <Paper>
                <Box>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="agent options"
                    >
                        <Tab label="Tagged Leads"/>
                        <Tab label="Matched Leads"/>
                        <Tab label="Resolved Leads"/>
                        <Tab label="Search Criteria"/>
                        <Tab label="Edit Profile"/>
                    </Tabs>
                </Box>
                {
                    tabValue === 0 && <AgentTaggedLeadsListView agentId={user.agentId} user={user}/>
                }
                {
                    tabValue === 1 && <AgentMappedRecordsListView  agentId={user.agentId} />
                }
                {
                    tabValue === 2 && <AgentResolvedLeadsListView  agentId={user.agentId} />
                }
                {
                    tabValue === 3 && <AgentSearchCriteriaListViewTile agentId={user.agentId}/>
                }
                {
                    tabValue === 4 && <AgentContactInfoView agentId={user.agentId}/>
                }
            </Paper>

        </Box>
    )

}

export default AgentDashboard;
